import { FC } from 'react';
import { getBookingStyles } from './BookingStyles';

const BookingLoading: FC = () => {
    return (
        <div className="status-screen">
            <style>{getBookingStyles()}</style>
            <div className="portal-loading">
                <div className="loading-bar"></div>
                <p>Authenticating...</p>
            </div>
        </div>
    );
};

export default BookingLoading;
